<script lang="ts">
	import { Toaster as Sonner } from 'svelte-sonner'
</script>

<Sonner
	class="toaster group z-50!"
	theme="dark"
	toastOptions={{
		classes: {
			toast:
				'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-branding-blue-10! group-[.toaster]:shadow-lg',
			title: 'w-full',
			description: 'group-[.toast]:text-muted-foreground',
			actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
			cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
			closeButton: 'border-branding-blue-10! left-auto! right-[-15px]!',
		},
	}}
	{...$$restProps}
/>
